import { getConfig as getSharedConfig } from '@newfront-insurance/shared-public-config';

export function getConfig() {
  return getSharedConfig();
}
